export default "__VITE_ASSET__86EU1Iw5__"